exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vux-check-icon{display:inline-block}.vux-check-icon>span{line-height:23px;color:#222;vertical-align:middle}.vux-check-icon>.weui-icon-success-circle:before,.vux-check-icon>.weui-icon-success:before{color:#2b88d8}", ""]);

// exports
